import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: { 'Content-Type': 'application/json' },
});

const CACHE_KEY_BODY_PARTS = 'replog-master-bodyParts';
const CACHE_KEY_EXERCISES = 'replog-master-exercises';

// マスターデータ取得（キャッシュ対応）
export const getBodyParts = async () => {
  if (navigator.onLine) {
    try {
      const res = await api.get('/master/bodyPart');
      localStorage.setItem(CACHE_KEY_BODY_PARTS, JSON.stringify(res.data));
      return res;
    } catch (err) {
      return { data: getCachedBodyParts() };
    }
  }
  return { data: getCachedBodyParts() };
};

export const getExercises = async () => {
  if (navigator.onLine) {
    try {
      const res = await api.get('/master/exercise');
      localStorage.setItem(CACHE_KEY_EXERCISES, JSON.stringify(res.data));
      return res;
    } catch (err) {
      return { data: getCachedExercises() };
    }
  }
  return { data: getCachedExercises() };
};

const getCachedBodyParts = () => {
  try {
    return JSON.parse(localStorage.getItem(CACHE_KEY_BODY_PARTS) || '[]');
  } catch {
    return [];
  }
};

const getCachedExercises = () => {
  try {
    return JSON.parse(localStorage.getItem(CACHE_KEY_EXERCISES) || '[]');
  } catch {
    return [];
  }
};

// トレーニング記録
export const getRecords = (params) => api.get('/records', { params });
export const createRecord = (data) => api.post('/records', data);
export const updateRecord = (recordId, data) => api.put(`/records/${recordId}`, data);
export const deleteRecord = (recordId) => api.delete(`/records/${recordId}`);

// 種目管理
export const createExercise = (data) => api.post('/master/exercise', data);
export const updateExercise = (data) => api.put('/master/exercise', data);
export const deleteExercise = (name) => api.delete(`/master/exercise/${encodeURIComponent(name)}`);